import { FaFacebookF, FaInstagram, FaXTwitter } from 'react-icons/fa6';

const FACEBOOK_URL = process.env.NEXT_PUBLIC_FACEBOOK_URL || '#';
const INSTAGRAM_URL = process.env.NEXT_PUBLIC_INSTAGRAM_URL || '#';
const X_URL = process.env.NEXT_PUBLIC_X_URL || '#';
const BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || '/';
const BASE_URL_WWW = process.env.NEXT_PUBLIC_BASE_URL_WITH_WWW || BASE_URL;

export default function Footer() {
  return (
    <footer className="bg-primary text-white mt-12">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <h3 className="text-primary-light font-semibold mb-4">Impressum</h3>
            <p className="text-sm">Professionelle Autoverwertung seit über 10 Jahren.</p>
          </div>
          <div>
            <h3 className="text-primary-light font-semibold mb-4">Kontakt</h3>
            <p className="text-sm">
              Tel: <a href={`tel:${process.env.NEXT_PUBLIC_PHONE_NUMBER || ''}`} className="hover:text-primary-light font-semibold transition-all">{process.env.NEXT_PUBLIC_PHONE_NUMBER}</a>
            </p>
            <p className="text-sm">Email: <a href={`mailto:${process.env.NEXT_PUBLIC_EMAIL_URL || ''}`} className="hover:text-primary-light transition">{process.env.NEXT_PUBLIC_EMAIL_URL}</a></p>
          </div>
          <div>
            <h4 className="condensed1 text-primary-light font-semibold mb-4"><span>Unsere</span> Öffnungszeiten</h4>
            <div className="co-footer-open"><span className="day">Montag</span> <span className="time">8:00 bis 21:00 Uhr</span></div>
            <div className="co-footer-open"><span className="day">Dienstag</span> <span className="time">8:00 bis 21:00 Uhr</span></div>
            <div className="co-footer-open"><span className="day">Mittwoch</span> <span className="time">8:00 bis 21:00 Uhr</span></div>
            <div className="co-footer-open"><span className="day">Donnerstag</span> <span className="time">8:00 bis 21:00 Uhr</span></div>
            <div className="co-footer-open"><span className="day">Freitag</span> <span className="time">8:00 bis 21:00 Uhr</span></div>
            <div className="co-footer-open"><span className="day">Samstag</span> <span className="time">8:00 bis 21:00 Uhr</span></div>
            <div className="co-footer-open"><span className="day">Sonntag</span> <span className="time">geschlossen</span></div>

            {/* Schema.org OpeningHours LD+JSON */}
            <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Autoverwertung Brilon",
              "image": `${process.env.NEXT_PUBLIC_BASE_URL}/images/cars/hero.webp`,
              "telephone": process.env.NEXT_PUBLIC_PHONE_NUMBER || "0123456789",
              "priceRange": "€",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Brilon",
                "addressLocality": "Brilon",
                "postalCode": "3058",
                "addressCountry": "DE"
              },
              "openingHoursSpecification": [
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Monday", "opens": "08:00", "closes": "21:00" },
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Tuesday", "opens": "08:00", "closes": "21:00" },
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Wednesday", "opens": "08:00", "closes": "21:00" },
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Thursday", "opens": "08:00", "closes": "21:00" },
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Friday", "opens": "08:00", "closes": "21:00" },
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Saturday", "opens": "08:00", "closes": "21:00" },
                { "@type": "OpeningHoursSpecification", "dayOfWeek": "Sunday", "opens": "00:00", "closes": "00:00" }
              ]
            }) }} />
          </div>
        </div>
        <hr className="border-primary my-8" />
        <div className="flex flex-col md:flex-row md:items-center md:justify-between text-sm">
          <div className="flex items-center justify-center gap-4 mb-4 md:mb-0">
            {/* <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-primary-light transition text-2xl">
              <FaFacebookF />
            </a> */}
            <a href={X_URL} target="_blank" rel="noopener noreferrer" aria-label="X" className="hover:text-primary-light transition text-2xl">
              <FaXTwitter />
            </a>
            <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-primary-light transition text-2xl">
              <FaInstagram />
            </a>
          </div>
          <div className="text-center md:text-left">
            <p>© {new Date().getFullYear()} {BASE_URL}  — Alle Rechte vorbehalten.</p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-2">
              <a href={BASE_URL_WWW} className="hover:text-primary-light underline">Startseite</a>
              <span className="text-white/70">|</span>
              <a href={`${BASE_URL}/datenschutzerklarung`} className="hover:text-primary-light underline">Datenschutzerklärung</a>
            </div>
          </div>
          <div className="text-center md:text-right mt-4 md:mt-0">
          </div>
        </div>
      </div>
    </footer>
  )
}
